import React from 'react'
import { createBrowserRouter, Navigate } from 'react-router-dom'
import AppLayout from '../components/AppLayout/AppLayout'
import PrivateRoute from '../components/RouteVisibility/PrivateRoute/PrivateRoute'

// Routes
import { DASHBOARD_ROUTES } from './DashboardRoutes'
import { SETTINGS_ROUTES } from './SettingsRoutes'
import { AGENT_MANAGER_ROUTES } from './AgentManagerRoutes'
import { LOGIN_PATH, LOGIN_ROUTES } from './LoginRoutes'
import { ONBOARDING_ROUTES } from './OnboardingRoutes'
import { IMPORT_ROUTES } from './ImportRoutes'
import { CAMPAIGN_MANAGER_ROUTES } from './CampaignManagerRoutes'
import { HOME_ROUTES } from './HomeRoutes'
import { CAMPAIGN_DETAILS_ROUTES } from './CampaignDetailsRoutes'
import { CRM_CONNECT_ROUTES, CRM_STATUS_ROUTES } from './CrmRoutes'
import { UNDERWRITING_ROUTES } from './UnderwritingRoutes'
import { MAN_VS_MACHINE_CHECKOUT_ROUTES } from './ManVsMachineCheckoutRoutes'
import { SCHEDULER_MANAGER_ROUTES } from './SchedulerManagerRoutes'

//Pages
import NotFoundPage from '../pages/NotFound/NotFoundPage'
import ErrorFallbackPage from '../pages/ErrorFallback/ErrorFallbackPage'

export const ROOT_PATH = '/'
export const NOT_FOUND_PATH = '/not-found'

export const router = createBrowserRouter([
	{
		index: true,
		element: <Navigate to={LOGIN_PATH} replace />,
	},
	...LOGIN_ROUTES,
	...ONBOARDING_ROUTES,
	...CRM_CONNECT_ROUTES,
	...MAN_VS_MACHINE_CHECKOUT_ROUTES,
	{
		path: ROOT_PATH,
		element: <PrivateRoute />,
		errorElement: <ErrorFallbackPage />,
		children: [
			{
				path: '',
				element: <AppLayout />,
				children: [
					...HOME_ROUTES,
					...IMPORT_ROUTES,
					...CAMPAIGN_DETAILS_ROUTES,
					...CAMPAIGN_MANAGER_ROUTES,
					...AGENT_MANAGER_ROUTES,
					...SETTINGS_ROUTES,
					...DASHBOARD_ROUTES,
					...UNDERWRITING_ROUTES,
					...SCHEDULER_MANAGER_ROUTES,
					{
						path: '*',
						element: <NotFoundPage />,
					},
				],
			},
			...CRM_STATUS_ROUTES,
		],
	},
])
